import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { simInfoColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getSimInfo } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "iccid", "msisdn", "account_number", "status", "last_updated"];

const SimInfoBatch = () => (
  <BatchDetail
    title="Sim Info"
    apiGet={__getSimInfo}
    client={CLIENTS.it}
    columnsFactory={simInfoColumns}
    copyKeys={COPY_KEYS}
    exportAction="sim_info"
    showTerminate
    terminateOperation="sim_info"
    disableRowClick
  />
);

export default SimInfoBatch;
